import config from '@/config'
const defaultCallbacks = {
  scroll() {
    if (config.debug) {
      // tslint:disable-next-line:no-console
      console.log('scroll callback is undefined')
    }
  },
  preload() {
    if (config.debug) {
      // tslint:disable-next-line:no-console
      console.log('preload callback is undefined')
    }
  },
  load() {
    if (config.debug) {
      // tslint:disable-next-line:no-console
      console.log('load callback is undefined')
    }
  },
  statechange() {
    if (config.debug) {
      // tslint:disable-next-line:no-console
      console.log('statechange callback is undefined')
    }
  },
  insufficientbalance() {
    if (config.debug) {
      // tslint:disable-next-line:no-console
      console.log('insufficientbalance callback is undefined')
    }
  },
  logoff() {
    if (config.debug) {
      // tslint:disable-next-line:no-console
      console.log('logoff callback is undefined')
    }
  },
  placebet() {
    if (config.debug) {
      // tslint:disable-next-line:no-console
      console.log('placebet callback is undefined')
    }
  },
  betslipoddscountchange() {
    if (config.debug) {
      // tslint:disable-next-line:no-console
      console.log('betslipoddscountchange callback is undefined')
    }
  },
  showloginbox() {
    if (config.debug) {
      // tslint:disable-next-line:no-console
      console.log('showloginbox callback is undefined')
    }
  },
  placebetplatformerror() {
    if (config.debug) {
      // tslint:disable-next-line:no-console
      console.log('placebetplatformerror callback is undefined')
    }
  },
  betreservation(args?: any) {
    if (config.debug) {
      // tslint:disable-next-line:no-console
      console.log('betreservation callback is undefined')
    }
  },
  eventclick(eventId) {
    if (config.debug) {
      // tslint:disable-next-line:no-console
      console.log('eventclick callback is undefined')
    }
  },
  oddclick(eventId, selectionId) {
    if (config.debug) {
      // tslint:disable-next-line:no-console
      console.log('oddclick callback is undefined')
    }
  }
}
const callbacks = {
  ...defaultCallbacks,
  extend: extendCallback
}
export function extendCallback(params) {
  for (const prop of Object.keys(params)) {
    const splittedProp = String(prop).split('callback')[0]
    if (defaultCallbacks[splittedProp]) {
      callbacks[splittedProp] = params[prop]
    }
  }
}

export default callbacks
